import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative w-full overflow-hidden',
    container: 'container',
    wrap: 'flex flex-col items-center gap-8 lg:flex-row lg:gap-21.5',
    left: 'lg:pr-10 lg:pl-8',
    right: 'flex-none lg:order-2 lg:w-100 xl:w-178.5'
  },
  variants: {
    type: {
      normal: {
        left: 'order-2 lg:order-1 xl:m-0',
        right: 'order-1 lg:order-2 xl:-mr-9 xl:ml-0'
      },
      reverse: {
        left: 'order-2 lg:order-2 lg:pl-0 xl:m-0',
        right: 'order-1 lg:order-1 xl:mr-0 xl:-ml-9'
      }
    }
  }
});
